import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

import { UISearchField } from "../../../components/ui";

// Matches the events-list Filter search field: fixed 40px height and no
// border in any state (default / hover / focus) so the outline never shifts.
const SEARCH_FIELD_SX = {
  "& .MuiInputBase-root": {
    height: "40px",
    minHeight: "40px",
    minWidth: "350px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0 !important",
  },
  "& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline, & .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline":
    {
      border: "0 !important",
    },
};

/** Shared search + action row for the Team Management tabs. */
const TeamToolbar = ({ search, searchPlaceholder, onSearchChange, children }) => (
  <Box className="team-management__toolbar">
    <div className="team-management__search">
      <UISearchField
        name="search"
        value={search}
        placeholder={searchPlaceholder}
        onChange={onSearchChange}
        sx={SEARCH_FIELD_SX}
      />
    </div>
    <div className="team-management__toolbar-actions">{children}</div>
  </Box>
);

TeamToolbar.propTypes = {
  search: PropTypes.string.isRequired,
  searchPlaceholder: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  children: PropTypes.node,
};

TeamToolbar.defaultProps = {
  children: null,
};

export default TeamToolbar;
